// extracted by mini-css-extract-plugin
export default {"CartType":"CartTypeButton_CartType__AMN8o"};